export const settingsTypes = {
    REQUEST: 'Settings lodaing',
    SUCCESS: 'Settings loading successfully',
    ERROR: 'Settings loading error',
    CLEAR: 'Settings  clear',
};
